import Card from '../card/card'

const Projects = () => {
    return (
        <div id="Work">
            <h2 className="mt-10">Projects</h2>
            <div className="grid grid-cols-2 gap-4 mt-5 pb-10 926:flex 926:flex-col 926:gap-2.5 ">
                <Card
                    title="Code-directory"
                    stacks={[
                        'Nest.js',
                        'Node.js',
                        'React',
                        'Next.js',
                        'MongoDB',
                        'i18next',
                        'Passport.js',
                        'Nginx',
                        'Docker',
                        'DigitalOcean',
                        'GoDaddy',
                    ]}
                    linkWeb={'https://code-directory.com/'}
                    linkGit={
                        'https://github.com/Dzmitry-Rybak/code-directory.com'
                    }
                />
                <Card
                    title="Marvel Characters"
                    stacks={[
                        'React.js',
                        'REST API',
                        'JavaScript',
                        'CSS',
                        'HTML',
                    ]}
                    linkWeb={'https://marvel-characters-ivory.vercel.app/'}
                    linkGit={
                        'https://github.com/Dzmitry-Rybak/Marvel_Characters'
                    }
                />
                <Card
                    title="Barley-Break"
                    stacks={['JavaScript', 'CSS', 'HTML']}
                    linkWeb={'https://barley-break-seven.vercel.app/'}
                    linkGit={'https://github.com/Dzmitry-Rybak/Barley-Break'}
                />
                <Card
                    title="To-Do List"
                    stacks={['TypeScript', 'TailWindCSS', 'React']}
                    linkWeb={'https://to-do-typescript-sandy.vercel.app/'}
                    linkGit={'https://github.com/Dzmitry-Rybak/ToDo_typescript'}
                />
            </div>
        </div>
    )
}

export default Projects
